var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank__row-item flex align-items-center" },
    [
      _vm.rowData.rankOrder && _vm.rowData.rankOrder < 4
        ? _c(
            "div",
            { staticClass: "yxtbiz-rank__row-item-order" },
            [
              _c("yxt-svg", {
                attrs: {
                  width: "24px",
                  height: "24px",
                  "remote-url": _vm.sspSvgCdn,
                  "icon-class": "rank_no" + _vm.rowData.rankOrder,
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "standard-size-16 text-8c yxtbiz-rank__row-item-order yxtf-weight-6",
            },
            [_vm._v("\n    " + _vm._s(_vm.rowData.rankOrder) + "\n  ")]
          ),
      _vm.contentObj.hasHead
        ? _c(
            "div",
            {
              staticClass: "pr12 flex",
              class: _vm.disabledSkip ? "cursor-default" : "cursor-point",
              on: {
                click: function ($event) {
                  !_vm.disabledSkip && _vm.linkToUserIndex(_vm.rowData.userId)
                },
              },
            },
            [
              _c("yxtf-portrait", {
                attrs: {
                  size: "48px",
                  "img-url":
                    _vm.rowData.contents[_vm.dictionaryKeys.userImgUrl],
                  username:
                    _vm.rowData.contents[_vm.dictionaryKeys.userName] || "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex-1 yxtbiz-rank__row-item-content",
          class: _vm.disabledSkip ? "cursor-default" : "cursor-point",
          on: {
            click: function ($event) {
              !_vm.disabledSkip && _vm.linkToUserIndex(_vm.rowData.userId)
            },
          },
        },
        [
          _vm.contentObj.primaryCode
            ? _c("primary-content", {
                staticClass: "font-size-14",
                class: {
                  "yxtf-weight-6":
                    _vm.contentObj.secondaryCodes &&
                    _vm.contentObj.secondaryCodes.length,
                },
                attrs: {
                  code: _vm.contentObj.primaryCode,
                  name: _vm.rowData.contents[_vm.contentObj.primaryCode],
                },
              })
            : _vm._e(),
          _vm.contentObj.secondaryCodes && _vm.contentObj.secondaryCodes.length
            ? _c("secondary-content", {
                staticClass: "text-8c",
                attrs: {
                  codes: _vm.contentObj.secondaryCodes,
                  contents: _vm.rowData.contents,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.contentObj.attributeCode
        ? _c(
            "div",
            {
              staticClass:
                "standard-size-16 text-59 ml24 yxtbiz-rank__row-item-attribute-content",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.numberUnit(
                      _vm.rowData.contents[_vm.contentObj.attributeCode]
                    )
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm.contentObj.attributeCode && _vm.styleObject.styleType === 2
        ? _c("div", { staticClass: "ml8 standard-size-14 text-8c" }, [
            _vm._v("\n    " + _vm._s(_vm.contentObj.attributeName) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }